<template>
    <div
        class="OrganisationRanking"
        v-skeleton="{
            loading: loading,
            sizes: {
                Small: { width: '12rem', height: '0.75rem' },
            }
        }"
    >
        <div
            v-if="hasDisciplineRanking || hasWorldwideRanking"
            class="Discipline"
        >
            {{ rankingPositionPercentage }}
        </div>
        <div
            v-if="hasWorldwideRanking"
            class="Worldwide"
        >
            <template
                v-if="(!hasDisciplineRanking && !hasRankingSorting) || hasDisciplineRanking"
            >
                <b>
                    <template v-if="!hasDisciplineRanking">
                        #{{ worldwideRankingPosition }}
                    </template> Worldwide
                </b>
                •
            </template>
            <span>Global Top {{ worldwideRankingPercentage }}%</span>
        </div>
    </div>
</template>


<script setup lang="ts">
import { computed } from 'vue';
import { useSearchStore } from '@stores/useSearchStore';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { UNIVERSITY_RANKINGS_SORT } from '@app/routing/mappers/SortMapper';

const searchStore = useSearchStore();

const props = defineProps({
    rankingDiscipline: {
        type: Number,
        required: false,
    },
    disciplineName: {
        type: String,
        required: false,
    },
    worldwideRankingPosition: {
        type: Number,
        required: false,
    },
    worldwideRankingPercentage: {
        type: String,
        required: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const hasDisciplineRanking = computed(() => props.rankingDiscipline && props.disciplineName);
const hasWorldwideRanking = computed(() => props.worldwideRankingPosition && props.worldwideRankingPercentage);
const hasRankingSorting = computed(() => !!searchStore?.filtersSelection?.find(filter =>
    filter.type === FilterType.SORTING &&
    filter.values?.some(value => value.id === UNIVERSITY_RANKINGS_SORT)
));
const rankingPositionPercentage = computed(() => {
    if (hasDisciplineRanking.value) {
        return `#${props.rankingDiscipline} in ${props.disciplineName}`;
    }

    return `#${props.worldwideRankingPosition} Worldwide`;
});
</script>


<style scoped lang="scss">
    .OrganisationRanking {
        display: flex;
        gap: 0.25rem;
        flex-direction: column;

        .Discipline {
            color: $Grey-900;
            @include TextStyle(UiMediumBold);
        }

        .Worldwide {
            display: flex;
            gap: 0.25rem;
            justify-content: flex-start;
            align-items: center;
            color: $Grey-700;

            span {
                color: $Grey-900;
                @include TextStyle(UiSmallRegular);
            }

            b {
                color: $Grey-900;
                @include TextStyle(UiSmallSemibold);
            }
        }
    }
</style>